<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('B0400.titles[3]')}}</span>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field :label="$t('app.labels.package.containerNo')" v-model="form.containerNo"></v-text-field>
            <!-- <v-autocomplete :items="container" :label="$t('app.labels.package.containerNo')" v-model="form.containerNo"></v-autocomplete> -->
          </v-flex>
          <v-flex xs12>
            <remote-select
              :label="$t('app.labels.package.containerSize')"
              type="number"
              url="container-types/kv"
              v-model="form.containerTypeId"
            ></remote-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-btn @click="submit">{{$t('app.buttons.add')}}</v-btn>
        <v-btn @click="show = false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      form: {
        containerNo: null,
        containerTypeId: null
      },
      resolve: null,
      reject: null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.form)
    }
  }
}
</script>
